/*@flow*/
import isString from 'lib/t/isString';
import isFunction from 'lib/t/isFunction';
import assert from 'lib/t/assert';
import hasOwn from 'lib/hasOwn';
import * as registry from '../templates/registry';
import templates from '../templates';

export default function getTemplate(
  options: $Shape<{ template?: Function | string }>,
  name: string
) {
  if (hasOwn.call(options, 'template')) {
    const tmpl = options.template;
    if (isFunction(tmpl)) {
      return tmpl;
    } else if (isString(tmpl)) {
      return registry.get(tmpl);
    }
      throw new Error(
        '[proforma] Expected options.template to be a string or a Function, but found ' +
          typeof tmpl
      );
  }
  assert(
    hasOwn.call(templates, name),
    '[proforma] Template `' + name + '` is not found.'
  );
  return templates[name];
}
